import {connect} from 'react-redux';

import Sport from '../Sport.jsx';

function select(state, props) {
    const sport = state.application.getIn(['live', 'sports', props.sportId]);
    const leagues = state.application.getIn(['live', 'leagues']);
    const displayMode = state.application.get('displayMode');

    return {
        ...props,
        displayMode,
        sport,
        leagues
    };
}

export default connect(select, null, null, false)(Sport);


// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/Sport.jsx